export default __webpack_public_path__ + "static/l8-portfolio-img-4-4718424ae44ce92a3909229e58481ef9.jpg";